<script>
  import { addDoc, collection } from "firebase/firestore"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import ResultadoEmpresa from "../components/empresa/Resultado_empresa.svelte"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import SinInformacion from "../components/Sin_informacion.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { db } from "../firebase"
  import { verifySession } from "../services/verifySession"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import Sidebar from "../components/Sidebar.svelte"
  import Container from "../components/Container.svelte"

  let ruc = ""

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)
      getPuntos()
    }

    if (!$user.permisos.includes("empresa")) {
      user.setUser(null)
      navigate("/", { replace: true })
    }

    //Pass
    if ($user.actualizar_clave == "1") {
      navigate("/seguridad", { replace: true })
    }

    //C
    if ($user.verificar == "1") {
      navigate("/verificar", { replace: true })
    }
  })

  let data = {
    empresas: undefined,
    loading: false,
  }

  const buscarEmpresa = async () => {
    await verifySession($user.session_key)
    if (!validarFormulario()) {
      alert("El RUC no es válido")
      return
    }
    reiniciarTiempo()
    addRuc()
    let session_key = $user.session_key
    let url = `${BASE_URL}empresa.php?ruc=${ruc}&session_key=${session_key}`
    data.loading = true
    const response = await fetch(url)
    const resp = await response.json()
    data = {
      empresas: resp.data,
      loading: false,
    }
  }

  const validarFormulario = () => {
    let validation = false
    ruc = ruc.trim()
    if (ruc.length === 11) validation = true
    return validation
  }

  const limpiar = () => {
    reiniciarTiempo()
    ruc = ""
  }

  const getPuntos = async () => {
    const response = await fetch(
      `${BASE_URL}session.php?session_key=${$user.session_key}`,
    )
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }
  }

  const addRuc = async () => {
    let tmp_ruc = {
      documento: ruc,
      tipo: "ruc",
    }
    try {
      await addDoc(collection(db, "documentos"), tmp_ruc)
    } catch (error) {
      console.error(error)
    }
  }

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }

  const reiniciarTiempo = () => {
    timer = tweened(original)
  }
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row min-vh-100">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid bg-2 flex-grow-1 py-5">
        <div class="row">
          <div class="col-12 xl:col-9 2xl:col-7">
            <Container>
              <h4 class="mb-5">
                <i class="bi bi-buildings fg-secondary me-1"></i>
                Búsqueda de Empresas
              </h4>
              <form
                on:submit|preventDefault={buscarEmpresa}
                class="row g-3 align-items-end mb-3"
              >
                <div class="col-12 lg:col">
                  <label
                    for="inputDocumentoE"
                    class="form-label small fg-secondary mb-1">RUC</label
                  >
                  <input
                    type="text"
                    id="inputDocumentoE"
                    class="form-control form-control-sm"
                    placeholder="Ingrese el RUC"
                    bind:value={ruc}
                  />
                </div>
                <div class="col-auto d-flex gap-3 justify-content-end">
                  <button
                    type="button"
                    class="btn btn-solid theme-neutral btn-sm"
                    on:click={limpiar}
                    ><i class="bi bi-eraser-fill"></i> Limpiar
                  </button>

                  {#if data.loading}
                    <button
                      type="submit"
                      class="btn btn-solid theme-primary btn-sm"
                      disabled
                    >
                      <i class="bi bi-search"></i> Buscando...
                    </button>
                  {:else}
                    <button
                      type="submit"
                      class="btn btn-solid theme-primary btn-sm"
                    >
                      <i class="bi bi-search"></i> Buscar
                    </button>
                  {/if}
                </div>
              </form>
            </Container>

            <div class="mt-5">
              {#if data.loading === true}
                <Spinner />
              {:else if data.empresas !== undefined}
                <Container>
                  <h5 class="mb-3">
                    <i class="bi bi-card-list fg-secondary me-1"></i>
                    Resultados de la búsqueda
                  </h5>
                  {#if data.empresas.error_id === undefined}
                    <ResultadoEmpresa empresas={data.empresas} />
                  {:else if data.empresas.message == "No tiene consultas disponibles"}
                    <SinInformacion message={data.empresas.message} />
                  {:else}
                    <SinInformacion />
                  {/if}
                </Container>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </main>
{/if}
